
import getNextNumerView from '../../../core/static/module/numberRange';
import productCreate from './module/CreateProducts'
import productUpdate from './module/UpdateProducts';
import productProcurementCreate from './module/ProductProcurementCreate';
import productProcurementUpdate from './module/ProductProcurementUpdate';
import batchNumberCreate from './module/BatchNumberCreate';
import batchNumberUpdate from './module/BatchNumberUpdate';
import AddStock from './module/AddStock';

import productProcuremenForm from './module/productProcuremenForm';
import FetchHandler from '../../../assets/js/assets/FetchHandler';

import ActivitiesList from '../../../activities/static/js/module/ActivitiesList';

import { productsStatistics } from './statistics/ProductStatistics';
import { movementsTable } from './statistics/MovementsTable';
import ProductNoteChangeHistory from './module/ProductsChangeHistory';

document.addEventListener('DOMContentLoaded', function() {
    new productCreate();
    new productUpdate();
    new productProcurementCreate();
    new productProcurementUpdate();
    new batchNumberCreate();
    new batchNumberUpdate();
    new ProductNoteChangeHistory();
    new AddStock();

    if(document.querySelector('#productProcuremenFormUpdate')){
        productProcuremenForm();        
    }


    if(document.querySelector('#productProcuremenFormUpdate') || document.querySelector('#productProcuremenFormCreate')){
        const productField = document.getElementById('id_product');

        function getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
        }
        async function loadProductUnit() {
            const productId = productField?.value;
            if (!productId) {
                const unitDisplay = document.querySelector('label[for="id_received_quantity"]');
                if (unitDisplay) unitDisplay.textContent = '';
                return;
            }
    
            try {
                const response = await fetch(`/api/products/detail/${productId}/`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${getCookie('drfToken')}`
                    }
                });
    
                if (response.ok) {
                    const data = await response.json();
                    const unitDisplay = document.querySelector('label[for="id_received_quantity"]');
                    if (unitDisplay && data.unit) {
                        unitDisplay.innerHTML = `Erhaltene Menge (${data.unit})<span class="asteriskField">*</span>`;
                    }
                }
            } catch (error) {
                console.error('Fehler beim Laden der Produkteinheit:', error);
            }
        }
    
        if (productField) {
            $(productField).on('select2:select', function() {
                loadProductUnit();
            });
            
            if (productField.value) {
                loadProductUnit();
            }
        }
    }

    const batchnumbergormcreate = document.getElementById('BatchNumberFormCreate');
    if(batchnumbergormcreate){
        fetch(`${getNextNumber}?modal=BAT`, {
            method: 'GET',
            headers: {
                'Authorization': `Token ${localStorage.getItem('token')}`
            },
        })
        .then(response => response.json())
        .then(data => {
            const fieldElement = document.getElementById('id_batch_number');
            
            if (!fieldElement) {
                console.log('Kein Feld gefunden');
                return;
            }
            
            if (data.error) {
                console.error('Fehler:', data.error);
                fieldElement.value = data.message || 'Ein Fehler ist aufgetreten.';
            } else if (data.formatted_number) {
                fieldElement.value = data.formatted_number;
            } else {
                fieldElement.value = data.message;
            }
        })
        .catch(error => {
            console.error('Fehler:', error);
        });
    }

    const serviceCreateForm = document.getElementById('productsCreateForm');
    if(serviceCreateForm){
        getNextNumerView('PRO');
    }

    async function getProductsDetail() {
        try {
            const response = await FetchHandler.getData(productsDeatile);
            const data = await response.json();

            if (data.qr_code) {
                const qrImg = document.querySelector('.placeholder');
                qrImg.src = data.qr_code;
                
                const downloadLink = document.createElement('a');
                downloadLink.href = data.qr_code;
                downloadLink.download = '';
                downloadLink.style.cursor = 'pointer';
                
                qrImg.parentNode.replaceChild(downloadLink, qrImg);
                downloadLink.appendChild(qrImg);
            }

            if (data.image) {
                document.querySelectorAll('.placeholder')[1].src = data.image;
                productImg.src = data.image;
                productImg.loading = 'eager';
            }
        } catch (error) {
            console.error(error);
        }
    }
    if (typeof productsDeatile !== 'undefined') {
        getProductsDetail();
        productsStatistics(productsId);
        movementsTable(productsId);
    }
    
    // Aktivitäten
    const activitiesProductsContainer = document.getElementById('activities-products-container');
    if(activitiesProductsContainer){
        const activitieslist = new ActivitiesList(activitiesList, 'activities-products-container');
        window.reloadActivitiesList = function () {
            if (typeof activitieslist !== 'undefined' && activitieslist) {
                activitieslist.init();
            }
        };
    }
    

});